import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "delivery",
    "deliveryCost",
    "deliveryCharge",
    "counterparty",
    "deliveryAddress",
    "driverName",
    "vehicleSelect",
    "vehicleText",
    "vehicleId",
    "driverNameInput"
  ]

  connect() {
    this.toggle()
  }

  toggle() {
    const delivery =
      this.deliveryTarget.tomselect?.getValue() || this.deliveryTarget.value

    // delivery_cost and delivery_charge: show for company or supplier
    const showCostFields = delivery === "company" || delivery === "supplier"
    this.toggleField(this.deliveryCostTarget, showCostFields)
    this.toggleField(this.deliveryChargeTarget, showCostFields)

    // counterparty_id: show for supplier
    this.toggleField(this.counterpartyTarget, delivery === "supplier")

    // delivery_address: show for company
    this.toggleField(this.deliveryAddressTarget, delivery === "company")

    // driver_name: show for company
    this.toggleField(this.driverNameTarget, delivery === "company")

    // vehicle select: show for company
    if (this.hasVehicleSelectTarget) {
      this.toggleField(this.vehicleSelectTarget, delivery === "company")
    }

    // vehicle text: show for supplier and pickup
    if (this.hasVehicleTextTarget) {
      this.toggleField(this.vehicleTextTarget, delivery !== "company")
    }
  }

  autoFillDriver() {
    if (!this.hasVehicleIdTarget || !this.hasDriverNameInputTarget) return

    const select = this.vehicleIdTarget
    const tomSelect = select.tomselect
    const selectedValue = tomSelect ? tomSelect.getValue() : select.value

    if (!selectedValue) return

    const selectedOption = Array.from(select.options).find(opt => opt.value === selectedValue)
    if (!selectedOption) return

    const driverName = selectedOption.dataset.driverName
    if (driverName) {
      this.driverNameInputTarget.value = driverName
    }
  }

  toggleField(target, show) {
    if (show) {
      target.style.display = ""
    } else {
      target.style.display = "none"
    }
  }
}
